import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import Header from './components/layout/Header';
import AuthenticationProvider from './context/AuthContext';
import { CssBaseline, ThemeProvider, GlobalStyles } from '@mui/material';
import theme from './assets/theme/theme';
import NotFound from './pages/public/NotFound';
// import Footer from './components/layout/Footer';
// import Footersocket from './components/layout/Footersocket';
import '../src/assets/styles/App.css';
import { AUTHENTICATION_PAGES, PRIVATE_PAGES, PROFILE_PAGES, PUBLIC_PAGES } from './lib/constants/routes';
// import ScrollToTop from './components/layout/ScrollToTop';
import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { deDE } from '@mui/x-date-pickers/locales';
import 'dayjs/locale/de';

import Layout from './components/layout/Layout';

function App() {
	const router = createBrowserRouter([
		{
			element: <Layout />,
			errorElement: (
				<>
					<Header />
					<NotFound />
				</>
			),
			children: [
				// **************************************************************************************************************
				// ***************************************  Navigation for All Users Only ***************************************
				// **************************************************************************************************************
				...PUBLIC_PAGES.map((ele) => ({
					path: ele.url,
					element: ele.element,
				})),

				//  **************************************************************************************************************
				//  **************************************  Navigation for Public Users Only *************************************
				//  **************************************************************************************************************
				...AUTHENTICATION_PAGES.map((ele) => {
					return {
						path: ele.url,
						element: ele.element,
					};
				}),

				// **************************************************************************************************************
				// **********************************  Navigation for Authenticated Users Only **********************************
				// **************************************************************************************************************
				...PRIVATE_PAGES.map((ele) => {
					return {
						path: ele.url,
						element: ele.element,
					};
				}),
				...PROFILE_PAGES.map((ele) => {
					return {
						path: ele.url,
						element: ele.element,
					};
				}),
			],
		},
	]);

	return (
		<>
			<GlobalStyles styles={{
				'@media print': {
					/* 					'@page': {
											size: 'A4',
										},
										'@page :blank': {
											'@top-center': { content: '"This page is intentionally left blank."' }
										},
										'.page': {
											margin: '20mm 15mm'
										}, */
					'#print-root': {
						width: '100%'
					},
					'#section-right-sidebar': {
						display: 'none !important'
					},
					'#logo-main': {
						display: 'none !important'
					},
					'body': {
						fontSize: '11pt'
					},
					'.page ~ .page': {
						'break-before': 'page'
					},
					'footer, button, svg, .buit-markdown-editor .mdxeditor-toolbar, .MuiAlert-root': {
						display: 'none !important'
					},
					'.MuiInputBase-input': {
						padding: '1rem 0 !important'
					}
				}
			}} />
			<LocalizationProvider
				dateAdapter={AdapterDayjs}
				adapterLocale="de"
				localeText={deDE.components.MuiLocalizationProvider.defaultProps.localeText}
			>
				<AuthenticationProvider>
					<ThemeProvider theme={theme}>
						<CssBaseline />
						<RouterProvider router={router}></RouterProvider>
					</ThemeProvider>
				</AuthenticationProvider>
			</LocalizationProvider>
		</>
	);
}

export default App;
